import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'event-container',
  templateUrl: './event-container.component.html',
  styleUrls: ['./event-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventContainer extends StaticContainer {
  
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/event-container/event-container.component.ts